import { useTranslation } from 'react-i18next'
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'

interface ConfirmCancelModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export function ConfirmCancelModal({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmCancelModalProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className='max-w-md' showCloseButton={false}>
        <DialogHeader>
          <DialogTitle className='text-lg font-semibold text-center'>
            {t('toolManagement.cancelImportTitle')}
          </DialogTitle>
        </DialogHeader>
        <div className='py-4'>
          <DialogDescription
            className='text-sm text-gray-600 text-center'
            dangerouslySetInnerHTML={{
              __html: t('toolManagement.cancelImportMessage'),
            }}
          />
        </div>
        <div className='flex gap-3 pt-4'>
          <Button
            type='button'
            variant='outline'
            onClick={onClose}
            className='flex-1'
          >
            {t('toolManagement.keepImporting')}
          </Button>
          <Button
            type='button'
            className='bg-red-600 hover:bg-red-700 flex-1'
            onClick={onConfirm}
          >
            {t('toolManagement.yesCancel')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
